'use client'
import { useEffect, useState, useCallback } from 'react'

export const useScrollPercentage = () => {
  const [scrollPercentage, setScrollPercentage] = useState(0)

  const calculateScrollPercentage = useCallback(() => {
    if (typeof window === 'undefined') {
      return 0
    }

    const scrollHeight =
      document.documentElement.scrollHeight - window.innerHeight
    const rawPercentage =
      (scrollHeight > 0 ? window.scrollY / scrollHeight : 0) * 100

    return Math.round(rawPercentage / 1) // round here to prevent to many state updates
  }, [])

  useEffect(() => {
    const updatePosition = () => {
      const newPercentage = calculateScrollPercentage()
      setScrollPercentage(newPercentage)
    }

    window.addEventListener('scroll', updatePosition)
    updatePosition() // Initial calculation

    return () => window.removeEventListener('scroll', updatePosition)
  }, [calculateScrollPercentage])

  return scrollPercentage
}
